export const textTruncate = (str: string, len = 15) => {
  return str?.length > len ? str?.substring(0, len) + "..." : str;
};
